import unemploymentReasons from "#src/data/unemploymentReasons.js";
import { useInsuredOccupationStore } from "#src/stores/insured-occupation.js";
import { valOrNull } from "#src/util/helpers.js";

export class InsuredOccupationPrefillService {
  #pinia;

  constructor(pinia) {
    this.#pinia = pinia;
  }

  setFromPrefill(insuredType, prefillData) {
    const occupation = useInsuredOccupationStore(insuredType, this.#pinia);
    if (!prefillData) return;

    const attributes = {
      valid: [],
      unchanged: [],
      invalid: {},
    };
    const prefilledData = this.#normalize(prefillData);
    const stateKeys = Object.keys(occupation.$state).filter(
      v => occupation.$state[v]?.load
    );
    stateKeys.forEach(key => {
      if (
        occupation[key].model === prefilledData[key] ||
        prefilledData[key] === null
      ) {
        attributes.unchanged.push(key);
        return;
      }

      occupation[key].model = prefilledData[key];
      const isValid = occupation[key].validate();
      if (isValid) {
        attributes.valid.push(key);
      } else {
        attributes.invalid[key] = occupation[key].errorMessages;
        occupation[key].load(null);
      }
    });

    return attributes;
  }

  async savePrefill(insuredType, attributesToUpdate) {
    if (!attributesToUpdate.length) return;
    const occupation = useInsuredOccupationStore(insuredType, this.#pinia);

    const savableKeys = Object.keys(occupation.$state).filter(
      v => occupation.$state[v]?.load
    );
    const keysToSave = savableKeys.filter(v => attributesToUpdate.includes(v));
    try {
      await occupation.saveAttributes(keysToSave);
    } catch (e) {
      keysToSave.forEach(attr => occupation[attr].load(null));
      throw e;
    }

    const returnData = {};
    keysToSave.forEach(attr => {
      returnData[attr] = occupation[attr].model;
    });
    return returnData;
  }

  #normalize(initPrefill) {
    let is_employed = null;
    if (initPrefill.occupation) {
      is_employed = !unemploymentReasons.includes(initPrefill.occupation);
    }

    let occupation_years = null;
    if (
      initPrefill.occupation_years ||
      [0, "0"].includes(initPrefill.occupation_years)
    ) {
      occupation_years = +initPrefill.occupation_years;
    }

    return {
      employer_name: valOrNull(initPrefill.employer),
      occupation_name: valOrNull(initPrefill.occupation),
      is_employed,
      occupation_years,
      employer_street_address: valOrNull(initPrefill.employer_street_address),
      employer_city: valOrNull(initPrefill.employer_city),
      employer_state: valOrNull(initPrefill.employer_state),
      employer_zip: valOrNull(initPrefill.employer_zip),
    };
  }
}
